import { GET_MARKET_DROP_DOWN_LIST, SET_MARKET_DROP_DOWN_LIST } from "./MarketType";

const getMarketDropDown = (regionCode: any) => ({
    type: GET_MARKET_DROP_DOWN_LIST,
    regionCode
});

const setMarketDropDown = (response: any) => ({
    type: SET_MARKET_DROP_DOWN_LIST,
    response
});

export {
    getMarketDropDown,
    setMarketDropDown
}